import {
  DefaultApi,
  GetUmpImportResultDto,
  GetUmpMediaplanDto,
  GetUmpPositionDto,
} from '../autogenerated/pokApiClient';

export interface UmpImportContextInterface {
  getEstimatesList: (
    estimateByMonthId: string,
  ) => Promise<GetUmpMediaplanDto[]>;
  getPositionsList: (
    estimateByMonthId: string,
    mediaplanUid: string,
  ) => Promise<GetUmpPositionDto[]>;
  importPositionsFromUpm: (
    estimateByMonthId: string,
    isPurchaseSameAsSales: boolean,
    positions: GetUmpPositionDto[],
    purchaserId?: string,
  ) => Promise<GetUmpImportResultDto>;
}

export const UmpImportContext = (api: DefaultApi) => {
  return {
    getEstimatesList: (estimateByMonthId: string) =>
      api.umpImportControllerGetEstimatesList(estimateByMonthId),
    getPositionsList: (estimateByMonthId: string, mediaplanUid: string) =>
      api.umpImportControllerGetPositionsList(estimateByMonthId, mediaplanUid),
    importPositionsFromUpm: (
      estimateByMonthId: string,
      isPurchaseSameAsSales: boolean,
      positions: GetUmpPositionDto[],
      purchaserId?: string,
    ) => {
      return api.umpImportControllerImportPositionsFromUmp(
        estimateByMonthId,
        isPurchaseSameAsSales,
        positions,
        purchaserId,
      );
    },
  };
};
